import { handleActions } from 'redux-actions';
import { INIT_STATE } from '../constants';
import {
  GET_LIST,
} from '../actions';

const rootReducer = handleActions({
  [GET_LIST]: (state, action) => state.set('list', action.data),
}, INIT_STATE);

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/pages/ucBindEmail/reducers/index.js
 **/